<div class="tooltip mobilehide">
    <div class="tooltip-rectangle">
        <div class="tooltip-arrow"></div>
        <p>{{message}}</p>
    </div>
</div>
<div class="mobile_tooltip desktophide" >
    <div class="main">
        <div><img src="{{path}}"/>
        </div>
        <div><img src="/assets/img/close.png" (click)="hidepopup()"/></div>
    </div>
    <p>{{message}}</p>
</div>
